import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=452d335b&scoped=true"
import script from "./Upsell.vue?vue&type=script&lang=js"
export * from "./Upsell.vue?vue&type=script&lang=js"
import style0 from "./Upsell.vue?vue&type=style&index=0&id=452d335b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d335b",
  null
  
)

export default component.exports